import axios from 'axios';

/***
* Library contains common Alatyr Framework functions and classes
* @author skadnikov 
*/

/***
 * Typed reference to other domain object
 * It references domain object by its GUID and {@link OntologyClassifier}
 *
 */
window['showErrorMessage'] = function(a,b) {
	console.error(a,b);
}

function SecurityRightCheckHandle(guid) {
	this.guid = guid;
	this.getGUID = function () {
		return this.guid;
	};
};

var pageContext = {};

function getSecutiryHeader(login, password) {
	return "<UserLogin>" + login + "</UserLogin><UserPassword>" + password + "</UserPassword>";
}

function getStaticSecutiryHeader() {
	//console.time('getStaticSecutiryHeader');
	var login = pageContext[USER_LOGIN_VARIABLE];
	if (!login) {
		var elem = document.getElementById("_" + USER_LOGIN_VARIABLE);
		login = elem ? elem.getAttribute("value") : '';
		pageContext[USER_LOGIN_VARIABLE] = login;
	}
	var password = pageContext[USER_PASSWORD_VARIABLE];
	if (!password) {
		var elem = document.getElementById("_" + USER_PASSWORD_VARIABLE);
		password = elem ? elem.getAttribute("value") : '';
		pageContext[USER_PASSWORD_VARIABLE] = password;
	}
	//console.timeEnd('getStaticSecutiryHeader');
	return login && password ? getSecutiryHeader(login, password) : null;
}


/**Creates new SOAP XML message for interaction with Alatyr Framework web service
 *@param operationName - System name of the target service operation
 *@param parameterNames - Array of String containing operation parameter names
 *@param parameterValues - Array of Object containing operation parameter values
 *@return SOAP XML message string
*/
function buildSOAPMessage(operationName, parameterNames, parameterValues, securityHeader) {
	var soapMessage = "<?xml version='1.0' encoding='utf-8'?>";
	soapMessage += "<soap:Envelope xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance'  ";
	soapMessage += "xmlns:xsd='http://www.w3.org/2001/XMLSchema' ";
	soapMessage += "xmlns:soap='http://schemas.xmlsoap.org/soap/envelope/'>";
	soapMessage += "<soap:Header>";
	soapMessage += "<SecurityHeader xmlns='http://tempuri.org/'>";
	soapMessage += securityHeader || getStaticSecutiryHeader() || "<TicketUID>" + getCurrentTicketUID() + "</TicketUID>";
	soapMessage += "</SecurityHeader>";
	soapMessage += "</soap:Header>";
	soapMessage += "<soap:Body>";
	soapMessage += "<" + operationName + " xmlns='http://analytics.alatyrsoftlab.com/'>";
	for (var i = 0; i < parameterNames.length; i++) {
		soapMessage += "<" + parameterNames[i] + " xmlns=''>";
		soapMessage += escapeHtmlEntities(stripScriptTagsFromHTML(stripCommentsFromHTML(parameterValues[i])));
		soapMessage += "</" + parameterNames[i] + ">";
	}
	soapMessage += "</" + operationName + ">";
	soapMessage += "</soap:Body>";
	soapMessage += "</soap:Envelope>";

	return soapMessage;
}


function parseXML(source) {
	var parser;

	if (typeof DOMParser !== 'undefined') {
		parser = function (str) {
			return (new window.DOMParser()).parseFromString(str, "text/xml");
		};
	} else if (typeof ActiveXObject !== 'undefined') {
		parser = function(str) {
			var xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
			xmlDoc.async = false;
			xmlDoc.loadXML(str);

			return xmlDoc;
		};
	} else {
		throw new Error('No XML parser found');
	}

	return parser(source);
}

var webserviceRestartCounter = 0;

/***
 * Sends given message to an xml-consuming Alatyr Framework  web service
 * @param serviceName Name of the service to call
 * @param soapMessage Service message data in xml format
 * @param resultHasComplexType Defines if service result is of complex type and need to be converted to JSON
 * @param serviceCallbackHandler Function handling service callback
 */

function callWebService(serviceName, soapMessage, resultHasComplexType, serviceCallbackHandler, serviceApplicationName, autoRestartOnError) {
	var rootPath = getWebServicesRootPath();
	rootPath = rootPath + "/" + (serviceApplicationName || 'atr-framework-services') + "/webservices/";

	if (!rootPath) {
		var msg = "Undefined variable that stores root address of web services";
		console.log(msg);
		alert(msg);
	} else {
		var queryString = buildURIQueryFromMap(getWebServiceQueryParams());
		var currentLanguage = getCurrentLanguage();
		var that = this, args = arguments;

		axios({
			method: 'post',
			url: rootPath + serviceName + (queryString ? '?' + queryString : ''),
			headers: {
				'Access-Control-Allow-Origin': '*',
				'Content-Type': 'text/xml',
				'X-ATR-User-Defined-Locale': currentLanguage
			},
			withCredentials: true,
			data: soapMessage
		}).then(function(response) {
			var data = response.data;

			if (data === null) {
				if (autoRestartOnError && webserviceRestartCounter < 5) {
					webserviceRestartCounter++;
					console.warn('resending request for webservice ' + serviceName + ', attempt #' + webserviceRestartCounter + '...');
					callWebService.apply(that, args);
				} else {
					return window.showErrorMessage("Ответ от сервиса " + serviceName + " равен null");
				}
			}
			var xml = parseXML(data);
			var authResultNode = xml.getElementsByTagName('AuthResult').item(0);
			var resultNode = xml.getElementsByTagName('return').item(0);
			// Read node containing returned result in JSON string
			var authResult = authResultNode && authResultNode.textContent;
			var resultString = resultNode && resultNode.textContent;

			if (authResult == 'error') {
				console.error('Auth error');
				window.location.href = '/atr-framework-services/login';
			} else {
				if (resultHasComplexType) {
					var jsonResult = {};
					try {
						if (resultString !== null && resultString !== '') {
							jsonResult = JSON.parse(resultString);
						}
					} catch (e) {
						window.showErrorMessage(
							"Ошибка при разборе JSON-ответа от сервиса " + serviceName,
							"JSON: " + resultString, e);
					}
					try {
						serviceCallbackHandler(jsonResult);
					}
					catch (e) {
						window.showErrorMessage("Ошибка при обработке ответа от сервиса " + serviceName, "", e);
					}
				} else {
					serviceCallbackHandler(resultString);
				}
			}
			webserviceRestartCounter = 0;
		}).catch(function(error) {
			var xhr = error.request;
			var responseText = error.response.data;
			var responseXML = xhr.responseXML;
			var status = error.response.status;
			var statusText = error.response.statusText;

			console.log(responseText);
			console.log(responseXML);
			console.error(statusText, xhr);
	
			if (responseText) {
				if (status === 0) {
					console.error('Request didn\'t reach the server - was not sent');
				} else {
					if (autoRestartOnError && webserviceRestartCounter < 5) {
						webserviceRestartCounter++;
						console.warn('resending request for webservice ' + serviceName + ', attempt #' + webserviceRestartCounter + '...');
						callWebService.apply(that, args);
					} else {
						// For some reasons when i do $ with SOAP response i get SOAP:Fault immediately
						var xml = parseXML(responseText);
						var errorNode = xml.getElementsByTagName('faultstring')[0];
						var errorText = errorNode && errorNode.innerHTML;
						window.showErrorMessage("Ошибка при обращении к сервису " + serviceName,
							errorText + "; Статус сервера: " + status + " / " + statusText, null, xhr, soapMessage);
					}
				}
			} else {
				var errorText = 'Неизвестная ошибка';
				window.showErrorMessage("Ошибка при обращении к сервису " + serviceName,
					errorText + "; Статус сервера: " + status + " / " + statusText, null, xhr, soapMessage);
			}
		});
	}
}

var webServiceQueryParams = {};

function getWebServiceQueryParams() {
	return webServiceQueryParams;
}

function buildURIQueryFromMap(map) {
	return Object.keys(map, function (key) {
		return key + '=' + map[key];
	}).join('&');
}

/***
 * Returns web services root path
 */
function getWebServicesRootPath() {
	var rootPath = pageContext[WEB_SERVICES_ROOT_VARIABLE];
	if (!rootPath) {
		var elem = document.getElementById("_" + WEB_SERVICES_ROOT_VARIABLE);
		rootPath = elem ? elem.getAttribute("value") : '';
		pageContext[WEB_SERVICES_ROOT_VARIABLE] = rootPath;
	}

	return rootPath;
}

/***
 * Returns current user login
 */
function getCurrentTicketUID() {
	var ticketUID = pageContext[TICKET_UID_VARIABLE];
	if (!ticketUID) {
		var elem = document.getElementById("_" + TICKET_UID_VARIABLE);
		ticketUID = elem ? elem.getAttribute("value") : (getURLParameterByName(TICKET_UID_VARIABLE) || getURLParameterByName('ticketUID'));
		pageContext[TICKET_UID_VARIABLE] = ticketUID;
	}

	return ticketUID;
}

function escapeHtmlEntities(text) {
	if (typeof (text) !== 'string') return text;
	// all HTML4 entities as defined here: http://www.w3.org/TR/html4/sgml/entities.html
	var entityTable = {
		60: 'lt', 62: 'gt', 34: 'quot', 38: 'amp', 39: 'apos'
	};
	return text.replace(/[\u00A0-\u2666<>\&'"]/g, function (c) {
		return '&' + (entityTable[c.charCodeAt(0)] || '#' + c.charCodeAt(0)) + ';';
	});
}

function stripScriptTagsFromHTML(html) {
	if (typeof (html) !== 'string') return html;
	if (html.indexOf('<script') >= 0) {
		var div = document.createElement('div');
		div.innerHTML = html;
		var scripts = div.getElementsByTagName('script');
		var i = scripts.length;
		while (i--) {
			scripts[i].parentNode.removeChild(scripts[i]);
		}
		return div.innerHTML;
	}
	else {
		return html;
	}
}

function stripCommentsFromHTML(html) {
	if (typeof (html) !== 'string') return html;
	if (html.indexOf('<!--') >= 0 && html.indexOf('-->') >= 0) {
		return html.replace(/<!--(.*?)-->/g, '');
	}
	else {
		return html;
	}
}

function getCurrentLanguage() {
	return 'ru';
}

function getURLParameterByName(name) {
	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
		results = regex.exec(location.search);
	return results == null ? "" : escapeHtmlEntities(decodeURIComponent(results[1].replace(/\+/g, " ")));
}

var coreLibContainer = {
	pageContext: pageContext,
	getWebServicesRootPath: getWebServicesRootPath,
	SecurityRightCheckHandle: SecurityRightCheckHandle,
	buildSOAPMessage: buildSOAPMessage,
	callWebService: callWebService
};

for (var k in coreLibContainer) {
	window[k] = coreLibContainer[k];
}
